import React from "react";
import "./ControlView.css";
import SettingsView from "./SettingsView";
import {Button} from "react-bootstrap";
import {useFormikContext} from "formik";
import {useEditContext} from "./EditContext";
import {WalkMap} from "./types";
import OpenView from "./OpenView";

const ControlView = () => {
  const {
    values: walkMap,
    isSubmitting,
    handleSubmit,
  } = useFormikContext<WalkMap>();
  const {setUpdatingCoordinate, updatingCoordinate, setEditNode} =
    useEditContext();

  return (
    <div className="ControlView">
      <div className="ControlView-buttons">
        <Button
          variant="light"
          active={updatingCoordinate === -1}
          disabled={!walkMap.image}
          onClick={() => {
            if (updatingCoordinate === -1) {
              setUpdatingCoordinate(null);
            } else {
              setUpdatingCoordinate(-1);
            }
          }}>
          Add Point
        </Button>
        <Button variant="light" onClick={() => setEditNode(<SettingsView />)}>
          Settings
        </Button>
        <Button
          variant="primary"
          disabled={isSubmitting}
          onClick={() => handleSubmit()}>
          Save
        </Button>
        <Button variant="secondary" onClick={() => setEditNode(<OpenView />)}>
          Open
        </Button>
      </div>
      <div className="ControlView-points"></div>
    </div>
  );
};

export default ControlView;
